module.exports = __webpack_public_path__ + "img/item-4.cd2b1fb.png";